module.exports = __webpack_public_path__ + "img/logo_bbcl_footer.52a9b280.png";